import { defineStore } from 'pinia';
import http from './http';
import { Response } from '@/types';
import { useMenuStore } from './menu';
import { useAuthStore } from '@/plugins';
import { useLoadingStore } from './loading';
import baseRouterList from '@/router/baseRouter'


export interface Profile {
  account: Account;
  permissions: string[];
  role: string;

  data?: any
}

export interface Account {
  username: string;
  avatar: string;
  gender: number;
}

export interface userinfo {
  token: string;
}

export type TokenResult = {
  token: string;
  expires: number;
  code: number;
  data: userinfo
};
export const useAccountStore = defineStore('account', {
  state() {
    return {
      customName: '',
      account: {} as Account,
      permissions: [] as string[],
      role: '',
      avatar: '',
      logged: true,
    };
  },
  actions: {
    async login(username: string, password: string) {
      return http
        .request<TokenResult, Response<TokenResult>>('/client/login', 'post_json', { customNo: username, customPwd: password })
        .then(async (response) => {
          if (response.data.code === 200) {
            this.logged = true;
            http.setAuthorization(`${response.data.data.token}`, new Date(24 * 60 * 60 * 1000 + new Date().getTime()));
            await useMenuStore().getMenuList();
            this.profile()
            return response.data;
          } else {
            return Promise.reject(response);
          }
        });
    },
    async logout() {
      return new Promise<boolean>((resolve) => {
        localStorage.removeItem('stepin-menu');
        http.removeAuthorization();
        this.logged = false;
        resolve(true);
      });
    },
    async profile() {
      const { setAuthLoading } = useLoadingStore();
      setAuthLoading(true);
      return http
        .request<Account, Response<Profile>>('/client/custom/getInfo', 'get')
        .then((response) => {
          if (response.code === 200) {
            const { setAuthorities } = useAuthStore();
            const { customMobile, customName, avatar } = response.data.data;
            this.account = customMobile;
            this.customName = customName
            this.avatar = avatar
            // this.permissions = permissions;
            // this.role = role;
            // setAuthorities(permissions);
            return response.data;
          } else {
            return Promise.reject(response);
          }
        })
        .finally(() => setAuthLoading(false));
    },
    setLogged(logged: boolean) {
      this.logged = logged;
    },
  },
});
